import { render, staticRenderFns } from "./DialogDelect.vue?vue&type=template&id=1b51edca&scoped=true&"
import script from "./DialogDelect.vue?vue&type=script&lang=js&"
export * from "./DialogDelect.vue?vue&type=script&lang=js&"
import style0 from "./DialogDelect.vue?vue&type=style&index=0&id=1b51edca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b51edca",
  null
  
)

export default component.exports